/*
 * サブシステム名：入金
 * 機能名：入金入力
 */
import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'

import filter from '@/rahmen/utils/filters'
import header from '@/ddv2.library/header'

import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'

const DdEditCommonBar = () => import('@/components/DdEditCommonBar')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdDateBox = () => import('@/components/DdDateBox')
const DdNumericBox = () => import('@/components/DdNumericBox')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextBox = () => import('@/components/DdTextBox')

export default {
  name: 'NyukinEdit',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdEditCommonBar,
    DdCodeTextBox,
    DdDateBox,
    DdNumericBox,
    DdSubHeader,
    DdTextBox
  },
  data: () => ({
    id: 0,
    rec: {},
    // 入金取込フラグ(true = 取込, false = 画面入力)
    nyukinTorikomiFlg: false,
    invalidMessages: {},
    modeOfEdit: 2,
    modeKengen: 2,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    headersTantoshaList: header.mstJininHeaders,
    headersNyukinsakiList: header.mstTorihikisakiHeaders,
    headersJishaginkokozaList: header.mstJishaGinkoKouzaHeaders
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      tantoshaList: 'DDMasters/vwCMstEigyoshoJininList',
      nyukinsakiList: 'DDMasters/vwCMstTorihikisakiGetNyukinsaki',
      jishaginkokozaList: 'DDMasters/mstJishaGinkoKoza',
      eigyoshoList: 'DDMasters/mstEigyosho',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg',
      userEigyoshoCd: 'users/eigyoshoCd'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    // 人員マスタ(担当者コード)
    filteredTantoshaList () {
      const self = this
      const target = filter.dateFormatter(new Date())
      return this.tantoshaList.map((elem) => {
        elem.jininNm = elem.jininNmSei + (elem.jininNmMei ? ' ' + elem.jininNmMei : '')
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target &&
        (self.eigyoshoLockFlg || elem.eigyoshoCd === self.userEigyoshoCd)
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.jininCd > elem2.jininCd) { return 1 }
        if (elem1.jininCd === elem2.jininCd) { return 0 }
        return -1
      })
    },
    // 取引先マスタ(入金先コード)
    filteredNyukinsakiList () {
      const target = filter.dateFormatter(new Date())
      return this.nyukinsakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    // 自社銀行口座マスタ(銀行コード/支店コード)
    filteredJishaginkokozaList () {
      return this.jishaginkokozaList.map((elem) => {
        if (elem.kinyuKikanCd || elem.kinyuKikanShitenCd) {
          elem.dispGinkoCd = !elem.kinyuKikanCd ? elem.kinyuKikanShitenCd : !elem.kinyuKikanShitenCd ? elem.kinyuKikanCd : elem.kinyuKikanCd + '・' + elem.kinyuKikanShitenCd
        }
        elem.dispGinkoNm = elem.kinyuKikanNm + '・' + elem.kinyuKikanShitenNm
        return elem
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.kinyuKikanCd > elem2.kinyuKikanCd) { return 1 }
        if (elem1.kinyuKikanCd < elem2.kinyuKikanCd) { return -1 }
        if (elem1.kinyuKikanShitenCd > elem2.kinyuKikanShitenCd) { return 1 }
        if (elem1.kinyuKikanShitenCd < elem2.kinyuKikanShitenCd) { return -1 }
        return 0
      })
      // return this.jishaginkokozaList
    },
    filteredTorihikisakiList () {
      return this.torihikisakiList.map((elem) => {
        return elem
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    isShoukaiMode () {
      return this.modeOfEdit === 1
    },
    isCancelButtonDisplay () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1) {
        return false
      }
      return true
    },
    isDeleteDisable () {
      return this.id === 0
    },
    isDeleteButtonDisplay () {
      if (this.modeKengen === 2 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isSaveButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    },
    isTorikomiShoukaiMode () {
      return this.modeOfEdit === 1 || this.nyukinTorikomiFlg === true
    }
  },
  created () {
    this.id = this.$route.params.id
    if (this.id === '0') {
      this.id = 0
    }
  },
  mounted () {
    this.initialize()
  },
  methods: {
    /**
     * setTantoshaCd 担当者IDからコードを取得
     * @param {*} tantoshaId
     * @returns jininCd
     */
    setTantoshaCd: function (tantoshaId) {
      console.log('●●setTantoshaCd：', tantoshaId)
      var tantosha = this.filteredTantoshaList.find(({ id }) => id === tantoshaId)
      if (tantosha !== undefined) {
        return tantosha.jininCd
      }
      return ''
    },
    /**
     * setTorihikisakiCd 入金先IDからコードを取得
     * @param {*} torihikisakiId
     * @returns torihikisakiCd
     */
    setTorihikisakiCd: function (torihikisakiId) {
      console.log('●●setTorihikisakiCd：', torihikisakiId)
      var torihikisaki = this.filteredNyukinsakiList.find(({ id }) => id === torihikisakiId)
      if (torihikisaki !== undefined) {
        return torihikisaki.torihikisakiCd
      }
      return ''
    },
    /**
     * setTantoshaId 担当者コードからIDを取得
     * @param {*} pTantoshaCd
     * @returns id
     */
    setTantoshaId: function (pTantoshaCd) {
      var tantosha = this.filteredTantoshaList.find(({ jininCd }) => jininCd === pTantoshaCd)
      if (tantosha !== undefined) {
        return tantosha.id
      }
      return -1
    },
    /**
     * setTorihikisakiId 入金先コードからIDを取得
     * @param {*} pTorihikisakiCd
     * @returns id
     */
    setTorihikisakiId: function (pTorihikisakiCd) {
      var torihikisaki = this.filteredNyukinsakiList.find(({ torihikisakiCd }) => torihikisakiCd === pTorihikisakiCd)
      if (torihikisaki !== undefined) {
        return torihikisaki.id
      }
      return -1
    },
    /**
     * setKinyuKikan 金融機関情報の設定
     * @param {*} pKbn 0:画面起動時, 1:保存時
     */
    setKinyuKikan: function (pKbn) {
      if (pKbn === 0) {
        // 画面起動時：銀行コードと支店コードから金融機関情報を設定
        var kinyuKikanFromCd = this.filteredJishaginkokozaList.find((elem) => {
          return elem.kinyuKikanCd === this.rec.kinyuKikanCd && elem.kinyuKikanShitenCd === this.rec.kinyuKikanShitenCd
        })
        if (kinyuKikanFromCd !== undefined) {
          this.rec.kinyuKikanId = kinyuKikanFromCd.id
          this.rec.kinyuKikanNm = kinyuKikanFromCd.kinyuKikanNm
          this.rec.shitenNm = kinyuKikanFromCd.kinyuKikanShitenNm
        }
      } else {
        // 保存時：選択されたIDから金融機関情報を設定
        var kinyuKikan = this.filteredJishaginkokozaList.find(({ id }) => id === this.rec.kinyuKikanId)
        console.log('●●setKinyuKikan：', kinyuKikan)
        if (kinyuKikan !== undefined) {
          this.rec.kinyuKikanCd = kinyuKikan.kinyuKikanCd
          this.rec.kinyuKikanNm = kinyuKikan.kinyuKikanNm
          this.rec.kinyuKikanShitenCd = kinyuKikan.kinyuKikanShitenCd
          this.rec.shitenNm = kinyuKikan.kinyuKikanShitenNm
        } else {
          console.log('●●setKinyuKikan(else)：', this.rec)
          this.rec.kinyuKikanCd = null
          this.rec.kinyuKikanNm = null
          this.rec.kinyuKikanShitenCd = null
          this.rec.shitenNm = null
        }
      }
      console.log('●●setKinyuKikan(this.rec)：', this.rec)
    },

    getCloneTargetMethod: function () {
      return this.rec
    },
    beforeRouteLeaveByMenu: function (next) {
      const opt = {
        nextCallback: next
      }

      this.preventTransition(opt)
    },
    fetchData: function () {
      const self = this
      return new Promise((resolve) => {
        console.log('★fetchData', self)
        console.log('★going to get', self.id)
        this.HttpClient
          .get(`/api/v1/TrNyukin/find?id=${self.id}`)
          .then((data) => {
            self.rec = data.payload

            delete self.rec.nyukinYmd

            // IDからコードを設定（表示項目）
            self.rec.tantoshaCd = self.setTantoshaCd(data.payload.tantoshaId)
            self.rec.torihikisakiCd = self.setTorihikisakiCd(data.payload.torihikisakiId)

            self.nyukinTorikomiFlg = self.rec.nyukinTorikomiFlg

            if (self.nyukinTorikomiFlg === false) {
              self.setKinyuKikan(0)
            }
            console.log('●●fetchData', self.rec)
            console.log('recived data', self.rec)
            resolve()
          })
      })
    },
    initialize () {
      const self = this
      const option = {
        loadMasters: ['msttorihikisaki', 'vwcmsteigyoshojininlist', 'vwcmsttorihikisakigetnyukinsaki', 'mstjishaginkokoza', 'msteigyosho'],
        initializeInputPromise: () => {
          return new Promise((resolve) => {
            self.rec = {
              nyukinNo: null,
              nyukinYmdString: '',
              tantoshaId: null,
              tantoshaCd: '',
              torihikisakiId: null,
              torihikisakiCd: '',
              kinyuKikanId: null,
              kinyuKikanCd: '',
              kinyuKikanNm: '',
              kinyuKikanShitenCd: '',
              shitenNm: '',
              genkin: '',
              furikomiKingaku: '',
              furikomiTesuryo: '',
              choseiKingaku: '',
              sosaiKingaku: '',
              tegata: '',
              kogitte: '',
              nyukinGokeiKingaku: '',

              henkoZumiFlg: false,
              minusNyukinFlg: false,
              nyukinTorikomiFlg: false,
              henkoMaeTrNyukinId: null,
              trSeikyuKihonId: null
            }
            console.log('initializeInputPromise')
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          return new Promise((resolve) => {
            // ユーザ保存項目の復元
            // console.log('★savedInputRestorePromise', c)
            // console.log('★savedInputRestorePromise', self.rec)
            // self.rec = { ...self.rec, ...c }
            // console.log('★savedInputRestorePromise', self.rec)
            resolve()
          })
        },
        existsIdMethod: () => {
          return self.id !== 0
        },
        requestApiPromise: self.fetchData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            // thisId == 0 then 新規モード
            if (self.id === 0) {
              self.modeOfEdit = 0 // 新規モード
            } else if (this.modeKengen === 0) {
              self.modeOfEdit = 1 // 照会モード
            } else {
              self.modeOfEdit = 2 // 更新モード
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        },
        settingItemMethod: (kengen) => {
          console.log('settingItemMethod', kengen)
        }
      }
      console.info('call initializeForRegister', this.initializeForRegister, option)
      this.initializeForRegister(option)
    },
    onReturnButtonClick: function (e) {
      console.log('onReturnButtonClick', e)
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }

      this.transitionBack(opt)
    },
    onCancelButtonClick: function (e) {
      console.log('onCancelButtonClick', e)
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            self.rec = data()
            self.rec.id = self.id
            resolve()
          })
        }
      }

      this.cancelInputs(opt)
    },
    onSaveButtonClick: function (e) {
      console.log('save', this)
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.id = data.payload.id
            console.log('●●registerResponsePromise', data)
            resolve()
          })
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            this.id = id
            this.transition(1, { id: id }, this.initialize)
            console.log('★transition')
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        },
        getSavedInputMethod: function () {
          return {
          }
        }
      }

      this.register(opt)
    },
    registerPromise: function () {
      let f
      // コードからIDを設定
      console.log('●●registerPromise(tantoshaCd,torihikisakiCd)', this.rec.tantoshaCd, this.rec.torihikisakiCd)
      this.rec.tantoshaId = this.setTantoshaId(this.rec.tantoshaCd)
      this.rec.torihikisakiId = this.setTorihikisakiId(this.rec.torihikisakiCd)
      // this.rec.kinyuKikanCd = this.setKinyuKikan(1)
      if (this.nyukinTorikomiFlg === false) {
        this.setKinyuKikan(1)
      }

      if (this.id === 0) {
        console.log('★登録処理')
        console.log('★rec', this.rec)

        this.rec.henkoZumiFlg = false
        this.rec.nyukinTorikomiFlg = false
        this.rec.minusNyukinFlg = false

        f = this.HttpClient.post('/api/v1/TrNyukin/CreateNyukinData', this.rec)
      } else {
        console.log('★更新処理')
        console.log('★rec', this.rec)
        console.log('●●registerPromise', this)

        f = this.HttpClient.post('/api/v1/TrNyukin/UpdateMulti', this.rec)
      }
      console.log('●●f', f)
      return f
    },
    onDeleteButtonClick: function (e) {
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            self.rec = self.cloneData
            self.HttpClient.post('/api/v1/TrNyukin/DeleteNyukinData', self.rec).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }
      this.delete(opt)
    },
    // 金額変更時に合計を再計算
    onChange: function () {
      this.rec.nyukinGokeiKingaku = Number(this.rec.genkin) +
                                    Number(this.rec.furikomiKingaku) +
                                    Number(this.rec.furikomiTesuryo) +
                                    Number(this.rec.choseiKingaku) +
                                    Number(this.rec.sosaiKingaku) +
                                    Number(this.rec.tegata) +
                                    Number(this.rec.kogitte)
      console.log('●●kingakuChange', this.rec)
    },
    registerValidate: function () {
      return true
    },
    deleteValidate: function () {
      return true
    }
  }
}
